import { render, staticRenderFns } from "./MyPuzzlesItem.vue?vue&type=template&id=0745fe86&scoped=true"
import script from "./MyPuzzlesItem.vue?vue&type=script&lang=js"
export * from "./MyPuzzlesItem.vue?vue&type=script&lang=js"
import style0 from "./MyPuzzlesItem.vue?vue&type=style&index=0&id=0745fe86&prod&lang=scss&scoped=true"
import style1 from "./MyPuzzlesItem.vue?vue&type=style&index=1&id=0745fe86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745fe86",
  null
  
)

export default component.exports